import PaymentContainer from "./PaymentContainer";
import PaymentStore from "./PaymentStore";

export default PaymentStore(PaymentContainer);